(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('StoredDocumentStatsController', StoredDocumentStatsController);

    StoredDocumentStatsController.$inject = ['StoredDocumentStats', 'AlertService'];

    function StoredDocumentStatsController(StoredDocumentStats, AlertService) {
        var vm = this;
        var FILE_TYPE_LABELS = {
            equipmentphoto: 'Photos des équipements',
            equipmentdoc: 'Documents des équipements',
            facture: 'Factures PDF',
            accounting: 'Exports comptables',
            signpict: 'Signatures',
            meterpict: 'Photos de compteur'
        };
        var STORAGE_LABELS = {
            s1: 'Persistant (s1)',
            s2: 'Temporaire (s2)'
        };

        vm.rows = [];
        vm.filteredRows = [];
        vm.searchText = '';
        vm.loading = false;
        vm.summary = buildSummary([]);

        vm.load = load;
        vm.applyFilter = applyFilter;
        vm.formatBytes = formatBytes;

        load();

        function load() {
            vm.loading = true;
            StoredDocumentStats.getAll().then(function(response) {
                vm.rows = (response.data || []).map(decorateRow);
                applyFilter();
            }).catch(function(error) {
                AlertService.error((error.data && error.data.message) || 'Impossible de charger les statistiques S3.');
            }).finally(function() {
                vm.loading = false;
            });
        }

        function applyFilter() {
            var searchText = (vm.searchText || '').trim().toLowerCase();
            vm.filteredRows = vm.rows.filter(function(row) {
                return !searchText || row.searchableText.indexOf(searchText) !== -1;
            });
            vm.summary = buildSummary(vm.filteredRows);
        }

        function decorateRow(row) {
            row.storageLabel = STORAGE_LABELS[row.storageSystem] || row.storageSystem;
            row.fileTypeLabel = FILE_TYPE_LABELS[row.fileType] || row.fileType;
            row.searchableText = [
                row.organisationName || '',
                row.storageLabel || '',
                row.fileTypeLabel || ''
            ].join(' ').toLowerCase();
            return row;
        }

        function buildSummary(rows) {
            var organisationIds = {};
            var organisationCount = 0;
            var totalFileCount = 0;
            var totalKnownSizeFileCount = 0;
            var totalSizeBytes = 0;
            var hasKnownSize = false;

            rows.forEach(function(row) {
                totalFileCount += row.fileCount || 0;
                totalKnownSizeFileCount += row.knownSizeFileCount || 0;
                if (row.organisationId !== null && row.organisationId !== undefined) {
                    organisationIds[row.organisationId] = true;
                }
                if (row.totalSizeBytes !== null && row.totalSizeBytes !== undefined) {
                    totalSizeBytes += row.totalSizeBytes;
                    hasKnownSize = true;
                }
            });
            angular.forEach(organisationIds, function() {
                organisationCount++;
            });

            return {
                groupCount: rows.length,
                organisationCount: organisationCount,
                totalFileCount: totalFileCount,
                totalKnownSizeFileCount: totalKnownSizeFileCount,
                totalSizeBytes: hasKnownSize ? totalSizeBytes : null
            };
        }

        function formatBytes(bytes) {
            var units = ['o', 'Ko', 'Mo', 'Go', 'To'];
            var value = bytes;
            var unitIndex = 0;

            if (bytes === null || bytes === undefined) {
                return '-';
            }
            while (value >= 1024 && unitIndex < units.length - 1) {
                value = value / 1024;
                unitIndex++;
            }
            return (unitIndex === 0 ? value : value.toFixed(1)) + ' ' + units[unitIndex];
        }
    }
})();
